
<template>
  <div ref="listWrap">
    <wrapper-list
      @calculate="paasCalculate"
      @batchClear="paasBatchClear"
      ref="listWrap" >
      <Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
        <row class="list-query-row">
          <FormItem label="来源方法" class="list-query-item">
            <Input  v-model="queryParam.query_LIKE_sourceMethod" placeholder=""
                    @on-change="queryTableDatas('param')" clearable />
          </FormItem>
        </row>
      </Form>
      <Table slot="table" stripe border :height="tableHeight"
             :data="tableData"
             :columns="tableColumns"
             @on-selection-change="selectTableDataChange"
             @on-sort-change="sortTableData"
             :no-data-text="noDataText">
      </Table>
      <Page slot="page"  :total="totalRecords"
            show-total show-sizer
            @on-change="changePage"
            @on-page-size-change="changePageSize">
      </Page>
    </wrapper-list>
  </div>
</template>
<script>
  import wrapperList from "@components/paas/wrapper-list";
  import metaList from "@assets/js/list/meta-list.js";
  import CellBar from '@components/paas/cell-bar' //列表内操作
  import {batchClear} from "@api/admin.js";
  export default {
    name: "list",
    mixins: [ metaList ],
    components: { wrapperList  ,CellBar},
    data() {
      return {
        serviceUrl:"/sys/exception",  //每个页面访问后台服务器的路径
        currentIdFiledName: 'id',
        queryParam:{
          query_LIKE_sourceMethod:"",
          queryOrderBy_: 'createTime@DESC',
        },
        defaultLabelWidth:200,
        tableColumns:[
          /*{
            title: '名称',
            key: 'name',
          },*/
          {
            title: '异常类型',
            key: 'exceptionType',
          },
          {
            title: '来源方法',
            key: 'sourceMethod',
          },
          {
            title: '创建时间',
            key: 'createTime',
            width:140
          },
          {
            title: '方法参数',
            key: 'methodParam',
          },
          {
            title: '提示信息',
            key: 'message',
          },
          {
            title: '操作',
            width:140,
            render: (h, params) => {
              return h(CellBar,
                {
                  props:{
                    show:'textIcon'  //操作也显示标准按钮的样式（text、icon、textIcon）
                  },
                  //自定义事件监听器“on”,不支持如v-on:keyup.enter的修饰符，需要手动匹配keyCode
                  on: {
                    // 子组件$emit传递函数,必须是箭头函数写法
                    /*'edit': ()=> {
                      this.$nextTick(()=>{
                        this.paasEditOper(params.row[this.currentIdFiledName]);
                      })
                    },*/
                    'delete':()=>{
                      this.$nextTick(()=>{
                        this.paasDeleteOper(params.row[this.currentIdFiledName]);
                      })
                    },
                  }
                }
              )
            }
          }
        ],
      }
    },
    mounted(){
    },
    methods:{
      /**
       * 清理所有异常
       */
      paasBatchClear(){
        batchClear().then(res=>{
          this.$Message.info("清理成功！");
        })
      }
    }
  }
</script>
